import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from "react";
import { array, arrayOf, node, shape, string } from "prop-types";
import Rex from "@icg360/rex";
import { Table } from "@icg360/ui-toolkit";
import { filterChangedDerivedForm, formatValue, mapEnumValuesToLabels } from "../../shared/utils";
import { pacDataPropTypes } from "../../shared/propTypes";
import _GroupWrapper from "../../shared/components/GroupWrapper";
import _SubgroupWrapper from "../../shared/components/SubgroupWrapper";

var Row = function Row(_ref) {
  var details = _ref.details,
      id = _ref.id,
      initialValue = _ref.initialValue,
      label = _ref.label,
      type = _ref.type,
      value = _ref.value;
  var currentValue = formatValue(initialValue, type, mapEnumValuesToLabels(details));
  var proposedValue = formatValue(value, type, mapEnumValuesToLabels(details));
  return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "col-xs-4"
  }, /*#__PURE__*/React.createElement("strong", {
    title: id
  }, label)), /*#__PURE__*/React.createElement("td", {
    className: "col-xs-4"
  }, currentValue), /*#__PURE__*/React.createElement("td", {
    className: "col-xs-4"
  }, proposedValue));
};

Row.propTypes = {
  details: arrayOf(shape({
    label: string,
    value: string
  })),
  id: string.isRequired,
  initialValue: string.isRequired,
  label: string.isRequired,
  type: string.isRequired,
  value: string.isRequired
};

var FormWrapper = function FormWrapper(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(Table, {
    style: {
      marginBottom: "0"
    }
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    className: "col-xs-4"
  }), /*#__PURE__*/React.createElement("th", {
    className: "col-xs-4"
  }, "Current Term"), /*#__PURE__*/React.createElement("th", {
    className: "col-xs-4"
  }, "Proposed Renewal"))), children);
};

FormWrapper.propTypes = {
  children: node.isRequired
};
var renderers = {
  string: Row,
  number: Row,
  currency: Row,
  enum: Row,
  range: Row,
  date: Row,
  zipcode: Row,
  email: Row
};
var wrappers = {
  SubgroupWrapper: function SubgroupWrapper(_ref3) {
    var label = _ref3.label,
        children = _ref3.children,
        inputs = _ref3.inputs;
    return _SubgroupWrapper({
      label: label,
      children: children,
      inputs: inputs,
      colSpan: 4
    });
  },
  GroupWrapper: function GroupWrapper(_ref4) {
    var label = _ref4.label,
        children = _ref4.children,
        inputs = _ref4.inputs;
    return _GroupWrapper({
      label: label,
      children: children,
      inputs: inputs,
      colSpan: 4
    });
  },
  FormWrapper: FormWrapper
};

var RexRenewalPreview = /*#__PURE__*/function (_Component) {
  _inheritsLoose(RexRenewalPreview, _Component);

  function RexRenewalPreview() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = RexRenewalPreview.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        derivedForm = _this$props.derivedForm,
        _this$props$pacData = _this$props.pacData,
        pacId = _this$props$pacData.pacId,
        policyActionId = _this$props$pacData.policyActionId;
    var changedDerivedForm = filterChangedDerivedForm(derivedForm);
    return /*#__PURE__*/React.createElement(Rex, {
      derivedForm: changedDerivedForm,
      renderers: renderers,
      wrappers: wrappers,
      useForm: {
        id: pacId,
        childId: policyActionId
      }
    });
  };

  return RexRenewalPreview;
}(Component);

RexRenewalPreview.propTypes = {
  derivedForm: array.isRequired,
  pacData: pacDataPropTypes
};
export { RexRenewalPreview as default };